import Skeleton from "@mui/material/Skeleton";
import styled from "@mui/material/styles/styled";

export const StyledSkeleton = styled(Skeleton)(({ theme: _ }) => ({
  width: "100%",
  height: "100%",
}));
